import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import WelcomeMessagesQuery, {
	type WelcomeMessagesQuery$data,
	type WelcomeMessagesQuery$variables,
} from './__generated__/WelcomeMessagesQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadWelcomeMessages(): Promise<{
	data: WelcomeMessagesQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<WelcomeMessagesQuery$data, WelcomeMessagesQuery$variables>({
		query: WelcomeMessagesQuery,
	});
}
